import CenterImageContentComponent from './CenterImageContent';
import ContentWithImageComponent from './ContentWithImage';

export const CenterImageContent = CenterImageContentComponent;
export const ContentWithImage = ContentWithImageComponent;
